export const SOURCE_OBJECT_PROCESSOR_TYPES = Object.freeze({
  REAL_TIME: 1,
  ASYNC: 2,
  BACKGROUND: 3
});

export const normalizeSourceObjectProcessorType = (value) => {
  if (value === undefined || value === null || value === "") {
    return SOURCE_OBJECT_PROCESSOR_TYPES.REAL_TIME;
  }

  if (typeof value === "number") {
    if (value === SOURCE_OBJECT_PROCESSOR_TYPES.ASYNC) return SOURCE_OBJECT_PROCESSOR_TYPES.ASYNC;
    if (value === SOURCE_OBJECT_PROCESSOR_TYPES.BACKGROUND) return SOURCE_OBJECT_PROCESSOR_TYPES.BACKGROUND;
    return SOURCE_OBJECT_PROCESSOR_TYPES.REAL_TIME;
  }

  const text = String(value).trim();
  const numeric = Number(text);
  if (Number.isFinite(numeric)) {
    return normalizeSourceObjectProcessorType(numeric);
  }

  const normalized = text.replace(/[\s_-]/g, "").toLowerCase();
  if (normalized === "async" || normalized === "asynchronous") {
    return SOURCE_OBJECT_PROCESSOR_TYPES.ASYNC;
  }
  if (normalized === "background" || normalized === "longrunning") {
    return SOURCE_OBJECT_PROCESSOR_TYPES.BACKGROUND;
  }

  return SOURCE_OBJECT_PROCESSOR_TYPES.REAL_TIME;
};

export const getSourceObjectProcessorType = (sourceObject) =>
  normalizeSourceObjectProcessorType(
    sourceObject?.ProcessorType ??
    sourceObject?.processorType ??
    sourceObject?.DefaultProcessor ??
    sourceObject?.defaultProcessor
  );

export const withSourceObjectProcessorOperationDefaults = (operation, sourceObject) => {
  if (!operation) return operation;
  const canSelectProcessor = operation.CanSelectProcessor ?? operation.canSelectProcessor;
  if (canSelectProcessor !== true) return operation;

  const processorType = getSourceObjectProcessorType(sourceObject);
  return {
    ...operation,
    CanSelectProcessor: false,
    canSelectProcessor: false,
    DefaultProcessor: processorType,
    defaultProcessor: processorType
  };
};
